import React, { useState, useEffect } from 'react'
import { Input, Form, Select, Button, DatePicker, Row, Col } from 'antd'
import * as API from '../../../../api'
import * as GLOBAL from '../../../../utils/global'

import './index.less'
const { Option } = Select
export interface ReptileSelectQuery {
	content?: string;
	createrWorkid?: string;
	name?: string;
	orderBy?: string;
}
export interface SearchProps {
	onSearch?: (val: ReptileSelectQuery) => void;
	addMedia?: () => void;
	btnAuth: string[];
	getInfoForm?: string;
}

const HeaderSearch: React.FC<SearchProps> = ({
	onSearch,
	addMedia,
	btnAuth,
	getInfoForm
}) => {
	const [form] = Form.useForm()
	const [typeList, setTypeList] = useState([])
	const [hotelCount, setHotelCount] = useState({ todayPass: 0, todayReject: 0, weekPass: 0, weekReject: 0, savingMoney: 0 })

	const getTypeList = async () => { // 内容形式
		const list  = await GLOBAL.getContentType('list')
		setTypeList(list)
	}
	const selectHotelCount = async () => {
		const { data } = await API.selectHotelCount(2)
		setHotelCount(data)
	}
	useEffect(() => {
		getTypeList()
		selectHotelCount()
		form.setFieldsValue(JSON.parse(getInfoForm))
	}, [])
	const submit = () => {
		form.validateFields().then(fieldsValue => {
			fieldsValue.beginUpdateTime = fieldsValue.beginUpdateTime&&fieldsValue.beginUpdateTime.format().split('T')[0] + ' ' + '00:00:00'
			fieldsValue.beginPublishTime = fieldsValue.beginPublishTime&&fieldsValue.beginPublishTime.format().split('T')[0] + ' ' + '00:00:00'
			!fieldsValue.beginPublishTime && delete fieldsValue.beginPublishTime
			!fieldsValue.beginUpdateTime && delete fieldsValue.beginUpdateTime
			onSearch && onSearch(fieldsValue)
		}).catch(err => {
			console.log(err)
		})
	}
	const reset = () => {
		form.setFieldsValue({
			stReview: '',
			title: '',
			type: '',
            stReviewNode:''
		})
	}

	const stReviewList = [{
		label: '审核通过',
		value: 'r0'
	},{
		label: '待审核',
		value: 'r1'
	},{
		label: '驳回',
		value: 'r4'
	}, {
		label: '已撤销',
		value: 'r5'
	}]
	const stReview = stReviewList.map(item => {
		return (
			<Option key={item.label} value={item.value} >{item.label}</Option>
		)
	})
    const stReviewNodeList = [{
		label: '提交',
		value: '0'
	},{
		label: '修改',
		value: '1'
	},{
		label: '业务审核',
		value: '2'
	}, {
		label: '法务审核',
		value: '3'
	},{
		label: '撤回',
		value: '4'
	},{
		label: '风控审核',
		value: '5'
	},{
		label: '品牌初审',
		value: '6'
	}, {
		label: '品牌终审',
		value: '7'
	},{
		label: '品牌微信审核',
		value: '8'
	}]
	const stReviewNode = stReviewNodeList.map(item => {
		return (
			<Option key={item.label} value={item.value} >{item.label}</Option>
		)
	})
	return (
		<div className="header-search">
			<Row className="media-info">
				<Col span={4}>
					<div className="number pass">{hotelCount.todayPass}</div>
					<div className="describe">今日通过条数</div>
				</Col>
				<Col span={4}>
					<div className="number pass">{hotelCount.weekPass}</div>
					<div className="describe">本周通过条数</div>
				</Col>
				<Col span={4}>
					<div className="number not-pass">{hotelCount.todayReject}</div>
					<div className="describe">今日不合规条数</div>
				</Col>
				<Col span={6}>
					<div className="number not-pass">{hotelCount.weekReject}</div>
					<div className="describe">本周不合规条数</div>
				</Col>
				<Col span={3}>
					<div className="number">{hotelCount.savingMoney}W</div><div className="describe">共计节省金额</div>
				</Col>
				<Col span={3}>
					{ btnAuth.includes('addMedia()') &&  <Button type="primary" onClick={addMedia}>上传内容</Button>}
				</Col>
			</Row>
			<Form
				layout="inline"
				form={form}
				initialValues={{
					orderBy: '1',
				}}
			>
				<Form.Item name="title" label="标题" style={{ width: '148px' }}>
					<Input />
				</Form.Item>
				<Form.Item name="type" label="内容形式" style={{ width: '148px' }}>
					<Select>
						<Select.Option value='' key=''>请选择</Select.Option>
						{
							typeList.map(item => {
								return (
									<Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>
								)
							})
						}
					</Select>
				</Form.Item>
				<Form.Item name="stReview" label="审核状态" style={{ width: '200px' }}>
					<Select>
						<Option key='全部' value=''>全部</Option>
						{stReview}
					</Select>
				</Form.Item>
                <Form.Item name="stReviewNode" label="审核节点" style={{ width: '200px' }}>
					<Select>
						<Option key='全部' value=''>全部</Option>
						{stReviewNode}
					</Select>
				</Form.Item>
				{/* <Form.Item name="createTimeOrder" label=" " colon={false} style={{ width: '160px' }}>
					<Select>
						<Select.Option value="">请选择</Select.Option>
						<Select.Option value="1">按创建时间倒序</Select.Option>
						<Select.Option value="0">按创建时间升序</Select.Option>
					</Select>
				</Form.Item> */}
				<Form.Item>
					<Button type="primary" onClick={submit}>搜索</Button>
					<Button type="primary" onClick={reset} style={{margin: '0 0 0 20px'}}>重置</Button>
				</Form.Item>
			</Form>
		</div>
	)
}
export default HeaderSearch